import React from 'react';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { GroupVisitsByDiscplineTable } from '../../groups/GroupVisitsByDiscplineTable';
import { ScheduleReportTable } from '../../report/ScheduleReportTable';
import { baseTotalColumns } from '../../groups/GroupedTotalsColumn';

const WeeklyTotalsDisciplineDataTable = createQueryDataTable('schedule-report-totals-discpline');
type RowType = RowOfQueryDataTable<typeof WeeklyTotalsDisciplineDataTable>;

const columnDefinitions = WeeklyTotalsDisciplineDataTable.columns([
	{
		header: 'Discipline',
		key: 'discipline',
		sortable: true
	},
	...baseTotalColumns<RowType>()
]);

export function WeeklyTotalsDisciplineTable(props: PropsOfQueryDataTable<typeof WeeklyTotalsDisciplineDataTable>) {
	return (
		<GroupVisitsByDiscplineTable
			columnDefinitions={columnDefinitions}
			searchType="schedule-report-totals-discpline"
			tableComponent={ScheduleReportTable}
			{...props}
		/>
	);
}
